// Share only concurrent reads. Settled responses are not cached, so returning
// to a listing still checks its current availability.
export function singleFlight(load) {
  const pending = new Map();
  return key => {
    if (!pending.has(key)) {
      pending.set(key, Promise.resolve().then(() => load(key)).finally(() => pending.delete(key)));
    }
    return pending.get(key);
  };
}
